(function () {
  const getSwiper = function () {
    if (typeof MinimogLibs !== 'undefined' && MinimogLibs.Swiper) return MinimogLibs.Swiper;
    if (typeof window.Swiper !== 'undefined') return window.Swiper;
    return null;
  };

  class StoreSlidertab extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.jsonEl = this.querySelector('[data-stores-json]');
      this.panel = this.querySelector('[data-detail-panel]');
      this.panelInner = this.querySelector('[data-detail-panel-inner]');
      this.hoverEnabled = this.dataset.hover === 'true';
      this.openOnLoad = this.dataset.openOnLoad === 'true';
      this.slides = this.querySelectorAll('[data-store-tab]');
      this.container = this.querySelector('.swiper-container');
      this.prev = this.querySelector('.m-store-slidertab__prev');
      this.next = this.querySelector('.m-store-slidertab__next');
      this.controls = this.querySelector('[data-slider-controls]');

      try {
        this.stores = this.jsonEl ? JSON.parse(this.jsonEl.textContent) : [];
      } catch (e) {
        this.stores = [];
      }

      this.activeIndex = -1;
      this.slider = null;
      this.supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this._onTabClick = this._onTabClick.bind(this);
      this._onTabEnter = this._onTabEnter.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);

      this.slides.forEach(function (btn) {
        btn.addEventListener('click', this._onTabClick);
        if (this.hoverEnabled && this.supportsHover) {
          btn.addEventListener('mouseenter', this._onTabEnter);
        }
      }, this);

      document.addEventListener('shopify:section:load', this._onSectionLoad);
      document.addEventListener('shopify:block:select', this._onBlockSelect);

      this.initSwiper();

      if (this.openOnLoad && this.stores.length) {
        this.setActive(0, { scrollSwiper: false, animate: false });
      }
    }

    disconnectedCallback() {
      this.destroySwiper();
      this.slides.forEach(function (btn) {
        btn.removeEventListener('click', this._onTabClick);
        btn.removeEventListener('mouseenter', this._onTabEnter);
      }, this);
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    _onSectionLoad(e) {
      if (!e.detail || String(e.detail.sectionId) !== String(this.sectionId)) return;
      this.destroySwiper();
      this.initSwiper();
    }

    _onBlockSelect(e) {
      if (e.detail && String(e.detail.sectionId) !== String(this.sectionId)) return;
      const t = e.target;
      if (!t || !this.contains(t)) return;
      const btn = t.closest ? t.closest('[data-store-tab]') : null;
      if (!btn) return;
      const idx = Number(btn.dataset.index);
      if (!Number.isNaN(idx)) this.setActive(idx, { scrollSwiper: true, animate: false });
    }

    initSwiper() {
      const SwiperCtor = getSwiper();
      if (!SwiperCtor || !this.container) return;

      this.destroySwiper();

      const total = this.stores.length;
      if (total < 1) return;

      const self = this;
      const gap = Math.max(0, parseInt(this.dataset.sliderGap, 10) || 0);

      let bpTablet = parseInt(this.dataset.sliderBreakpointTablet, 10) || 768;
      let bpDesktop = parseInt(this.dataset.sliderBreakpoint, 10) || 990;
      bpTablet = Math.max(320, bpTablet);
      bpDesktop = Math.max(bpTablet + 1, bpDesktop);

      let slidesMobile = parseFloat(String(this.dataset.slidesMobile || '').replace(',', '.'));
      if (!(slidesMobile > 0) || Number.isNaN(slidesMobile)) slidesMobile = 2.2;

      let slidesTablet = parseFloat(String(this.dataset.slidesTablet || '').replace(',', '.'));
      if (!(slidesTablet > 0) || Number.isNaN(slidesTablet)) slidesTablet = 3.5;

      let slidesDesktop = parseFloat(String(this.dataset.slidesDesktop || '').replace(',', '.'));
      if (!(slidesDesktop > 0) || Number.isNaN(slidesDesktop)) slidesDesktop = total;

      const designMode = this.dataset.designMode === 'true';
      const autoplayOn = this.dataset.sliderAutoplay === 'true' && !designMode;
      let autoplayDelay = parseInt(String(this.dataset.sliderAutoplayDelay || '').trim(), 10);
      if (Number.isNaN(autoplayDelay) || autoplayDelay < 1) autoplayDelay = 5000;
      autoplayDelay = Math.min(60000, Math.max(1000, autoplayDelay));

      const breakpoints = {};
      breakpoints[bpTablet] = {
        slidesPerView: slidesTablet,
        spaceBetween: gap,
      };
      breakpoints[bpDesktop] = {
        slidesPerView: slidesDesktop,
        spaceBetween: gap,
      };

      const swiperConfig = {
        slidesPerView: slidesMobile,
        spaceBetween: gap,
        watchOverflow: true,
        breakpoints: breakpoints,
        on: {
          init: function () {
            self._toggleControls(this);
          },
          breakpoint: function () {
            self._toggleControls(this);
          },
          resize: function () {
            self._toggleControls(this);
          },
        },
      };

      if (autoplayOn) {
        swiperConfig.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        };
      }

      this.slider = new SwiperCtor(this.container, swiperConfig);

      if (this.prev && this.next) {
        this._navPrevClick = function () {
          if (self.slider) self.slider.slidePrev();
        };
        this._navNextClick = function () {
          if (self.slider) self.slider.slideNext();
        };
        this.prev.addEventListener('click', this._navPrevClick);
        this.next.addEventListener('click', this._navNextClick);
      }
    }

    _toggleControls(swiper) {
      if (!this.controls) return;
      const locked = swiper && typeof swiper.isLocked === 'boolean' ? swiper.isLocked : false;
      const overflow = swiper && !locked;
      this.controls.classList.toggle('m:hidden', !overflow);
    }

    destroySwiper() {
      if (this.prev && this._navPrevClick) {
        this.prev.removeEventListener('click', this._navPrevClick);
        this._navPrevClick = null;
      }
      if (this.next && this._navNextClick) {
        this.next.removeEventListener('click', this._navNextClick);
        this._navNextClick = null;
      }
      if (this.slider && typeof this.slider.destroy === 'function') {
        try {
          this.slider.destroy(true, true);
        } catch (e) {}
        this.slider = null;
      }
    }

    _indexFromEvent(e) {
      const btn = e.currentTarget.closest('[data-store-tab]');
      if (!btn) return -1;
      return Number(btn.dataset.index);
    }

    _onTabClick(e) {
      e.preventDefault();
      const idx = this._indexFromEvent(e);
      if (idx < 0) return;

      const clickToggles = !this.hoverEnabled || !this.supportsHover;
      const panelOpen = this.panel && this.panel.classList.contains('is-open');

      if (clickToggles && panelOpen && idx === this.activeIndex) {
        this.closePanel();
        return;
      }

      this.setActive(idx, { scrollSwiper: true, animate: true });
    }

    _onTabEnter(e) {
      const idx = this._indexFromEvent(e);
      if (idx < 0) return;
      this.setActive(idx, { scrollSwiper: true, animate: true });
    }

    closePanel() {
      this.activeIndex = -1;
      this.slides.forEach(function (el) {
        el.classList.remove('is-active');
        el.setAttribute('aria-selected', 'false');
      });
      if (this.panel) {
        this.panel.classList.remove('is-open');
        this.panel.setAttribute('aria-hidden', 'true');
      }
    }

    setActive(index, opts) {
      const o = opts || {};
      const animate = o.animate !== false;
      const store = this.stores[index];
      if (!store) return;

      this.activeIndex = index;

      this.slides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      if (this.slider && o.scrollSwiper !== false) {
        try {
          this.slider.slideTo(index);
        } catch (e) {}
      }

      this.renderPanel(store, animate);
    }

    renderPanel(store, animate) {
      if (!this.panel || !this.panelInner) return;

      const phoneClean = (store.phone || '').replace(/[^\d+]/g, '');
      const tel = phoneClean ? 'tel:' + phoneClean : '';

      const phoneRow =
        store.phone && tel
          ? '<a class="m-store-slidertab__phone" href="' +
            this._escapeAttr(tel) +
            '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/></svg><span>' +
            this._escapeHtml(store.phone) +
            '</span></a>'
          : '';

      const viewBtn = store.store_url
        ? '<a class="m-store-slidertab__btn" href="' +
          this._escapeAttr(store.store_url) +
          '">View store</a>'
        : '';

      const callBtn =
        tel && store.phone
          ? '<a class="m-store-slidertab__btn m-store-slidertab__btn--ghost" href="' +
            this._escapeAttr(tel) +
            '">Call</a>'
          : '';

      const addressHtml = store.address
        ? '<p class="m-store-slidertab__address">' +
          this._escapeHtml(store.address).split('\n').join('<br>') +
          '</p>'
        : '';

      const hoursBlock =
        (store.hours
          ? '<p class="m-store-slidertab__hours-title">Business hours</p><div class="m-store-slidertab__hours rte">' +
            store.hours +
            '</div>'
          : '') +
        '<div class="m-store-slidertab__hours-actions">' +
        viewBtn +
        callBtn +
        '</div>';

      const mapHtml = this._mapEmbedMarkup(store.map_embed);

      this.panelInner.classList.toggle('m-store-slidertab__panel-inner--no-map', !mapHtml);

      this.panelInner.innerHTML =
        '<div class="m-store-slidertab__panel-col m-store-slidertab__panel-col--info">' +
        '<h3 class="m-store-slidertab__panel-title">' +
        this._escapeHtml(store.panel_title || '') +
        '</h3>' +
        addressHtml +
        phoneRow +
        '</div>' +
        '<div class="m-store-slidertab__panel-col m-store-slidertab__panel-col--hours">' +
        hoursBlock +
        '</div>' +
        (mapHtml
          ? '<div class="m-store-slidertab__panel-col m-store-slidertab__panel-col--map">' +
            '<div class="m-store-slidertab__map-inner" role="region" aria-label="Store location map">' +
            mapHtml +
            '</div></div>'
          : '');

      this.panel.classList.add('is-open');
      this.panel.setAttribute('aria-hidden', 'false');
      if (!animate) {
        this.panel.style.transition = 'none';
        void this.panel.offsetHeight;
        this.panel.style.transition = '';
      }
    }

    _escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    _escapeAttr(s) {
      return this._escapeHtml(s).replace(/'/g, '&#39;');
    }

    _mapEmbedMarkup(embed) {
      const raw = String(embed || '').trim();
      if (!raw) return '';
      const noScripts = raw.replace(/<script[\s\S]*?<\/script>/gi, '');
      if (!/<iframe/i.test(noScripts)) return '';
      return noScripts;
    }
  }

  if (!customElements.get('store-slidertab')) {
    customElements.define('store-slidertab', StoreSlidertab);
  }
})();
